// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CardDisplay{
    display: flex;
    
}
.template-name {
    font-weight: bold !important;
    font-size: 1rem !important;
    color: #333 !important;
    margin-top: 10px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
  .card-style{
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  .card-style:hover {
    transform: scale(1.05);
    box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.2);
    
  }

  .icon-button {
    position: absolute !important;
    top: 5px;
    right: 5px;
    background-color: #999;
    transition: background-color 0.3s ease, transform 0.3s ease;
  }
  
  .icon-button:hover {
    background-color: #484646;
    transform: scale(1.1);
  }
  .BackBtn {
    background-color: #82b2e4 !important;
    color: #fff !important;
    border: none;
    border-radius: 5px !important;
    padding: 10px 20px !important;
    cursor: pointer !important;
    transition: background-color 0.3s ease, transform 0.3s ease !important;
  }
  
  .BackBtn:hover {
    background-color: #2066b1 !important; /* Darker shade on hover */
    transform: scale(1.05) !important; /* Slight zoom-in */
    border-radius: 5px 5px 5px 5px !important;
  }

  .custom-modal-box-template {
    padding: 24px !important;
    background-color: white !important;
    border-radius: 10px !important;
    max-width: 500px !important;
    width: 90% !important; /* Responsive width */
    margin: auto !important;
    margin-top: 10% !important;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.2) !important; /* Subtle shadow */
  }
  
  /* Modal Title */
  .modal-title-template {
    font-size: 20px !important;
    font-weight: bold !important;
    margin-bottom: 16px !important;
    text-align: center !important;
  }
  
  /* Modal Input */
  .modal-input-template .MuiOutlinedInput-root {
    border-radius: 8px !important;
  }
  
  .modal-input-template .MuiInputLabel-root {
    font-size: 14px !important;
  }
  
  /* Modal Actions */
  .modal-actions {
    display: flex !important;
    justify-content: flex-end !important;
    gap: 16px !important;
    margin-top: 24px !important;
  }
  
  /* Buttons */
  .save-button-template {
    padding: 8px 16px !important;
    background-color: #0070E9 !important;
    color: #fff !important;

    &:hover {
        background-color: #005bb5 !important;
    }
  }
  
  .cancel-button-template {
    padding: 8px 16px !important;
    color: #555 !important;
    background-color: #f0f0f0 !important;
    

    &:hover {
        background-color: #e0e0e0 !important;
    }
  }


  /* ///////////////////////add goals//////////////// */
  .add-goals-container {
    /* padding: 20px; */
    display: flex;
    flex-direction: column;
  }
  
  .toggle-container {
    display: flex;
    justify-content: flex-end; /* Positions the toggle to the right end */
    align-items: center; /* Aligns the content vertically */
  }
  
  .toggle-wrapper {
    display: inline-flex;
    align-items: center;
    gap: 10px; /* Adds space between the toggle and label */
  }
  
  .toggle-label {
    color: gray;
    font-size: 14px;
  }
  
  .toggle-label.enabled {
    color: #00b562; /* Change color when enabled */
  }


  .assign-modal-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width: 50%;
    max-width: 60%;
    background-color: #ffffff; /* White background */
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1); /* Subtle shadow */
    padding: 20px;
    border-radius: 10px;
    max-height: 80vh; /* Restrict height for scroll */
    overflow-y: auto; /* Enable vertical scrolling */
  }
  
  /* Card Container */
  .assign-card-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-top: 30px;
   
  }
  
  /* Card Styling */
  .assign-card-style {
    width: 150px; /* Card width */
    padding: 20px; /* Card padding */
    text-align: center;
    cursor: pointer;
    height: 150px; /* Card height */
    position: relative;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1); /* Shadow for the card */
    border-radius: 10px; /* Rounded corners */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #f9f9f9; /* Light background color */
    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  }
  
  /* Card Hover Effect */
  .assign-card-style:hover {
    transform: scale(1.05); /* Slightly enlarge card on hover */
    box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.2); /* Stronger shadow on hover */
  }
  
  /* Card Media (Image) */
  .assign-card-media {
    border-radius: 5px; /* Rounded edges for the image */
  }
  
  /* Card Content */
  .assign-card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 10px;
    margin-left: auto;
    margin-right: auto;
  }

  .leavemanageHeadingcopy {
    font-family: "Inter";
    font-size: 22px;
    font-weight: 600 !important;
    line-height: 21.78px;
    letter-spacing: 0.02em;
    text-align: left;
    color: #0070E9;
    align-items: center;

}
  
  /* Template Name */
  .assign-template-name {
    font-weight: bold !important;
    font-size: 1rem !important;
    color: #333 !important;
    margin-top: 10px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    position: relative;
    max-width: 200px; /* Set a width to trigger ellipsis */
  }

  /* .assign-template-name:hover {
    overflow: visible !important;
    animation: slide 5s linear infinite;
  }
  
  @keyframes slide {
    0% {
      transform: translateX(-10);
    }
    100% {
      transform: translateX(-100%);
    }
  } */
  
  /* Scrollbar Styling for Modal */
  .assign-modal-box::-webkit-scrollbar {
    width: 8px;
  }
  
  .assign-modal-box::-webkit-scrollbar-thumb {
    background-color: #d6d6d6; /* Grey color for scrollbar */
    border-radius: 5px; /* Rounded scrollbar */
  }
  
  .assign-modal-box::-webkit-scrollbar-thumb:hover {
    background-color: #a8a8a8; /* Darker grey on hover */
  }
  
  .assign-modal-box::-webkit-scrollbar-track {
    background: #f1f1f1; /* Light background for track */
  }

  .assign-close-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    cursor: pointer;
    transition: color 0.2s ease-in-out;
  }
  
  .assign-close-icon:hover {
    color: #ff0000; /* Change color to red on hover */
  }
  
  /* Close Button */
  .assign-close-button {
    margin-top: 20px;
    display: block;
    padding: 10px 20px;
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
    background-color: #007bff; /* Blue background */
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.2s ease-in-out;
  }
  
  .assign-close-button:hover {
    background-color: #0056b3; /* Darker blue on hover */
  }


  /* EditModal.css */
.editmodal-container {
    padding: 24px !important;
    background-color: white !important;
    border-radius: 10px !important;
    max-width: 500px !important;
    width: 90% !important; /* Responsive width */
    margin: auto !important;
    margin-top: 10% !important;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.2) !important; /* Subtle shadow */
  }
  
  .editmodal-title {
    font-size: 20px !important;
    font-weight: bold !important;
    margin-bottom: 16px !important;
    text-align: center !important;
  }
  
  .editmodal-item {
    margin-bottom: 15px;
    font-size: 1rem;
  }
  
  .editmodal-item strong {
    font-weight: bold;
  }

  .editmodal-button{
    display: flex;
  justify-content: flex-end; /* Align buttons to the right */
  align-items: center;
  margin-top: 20px;
  gap: 20px; /* Add space between buttons */
  }
  
  .editmodal-Savebutton {
    padding: 8px 16px !important;
    background-color: #0070E9 !important;
    color: #fff !important;

    &:hover {
        background-color: #005bb5 !important;
    }
  }
  .editmodal-Cancelbutton {
    padding: 8px 16px !important;
    color: #555 !important;
    background-color: #f0f0f0 !important;
    

    &:hover {
        background-color: #e0e0e0 !important;
    }
  }
  
  
  .editmodal-input {
    margin-top: 10px;
  }
  
  @media (max-width: 600px) {
    .editmodal-container {
      width: 90%;
    }
  }

  .view-modal-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width: 50%;
    max-width: 60%;
    background-color: #ffffff; /* White background */
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1); /* Subtle shadow */
    padding: 20px;
    border-radius: 10px;
    max-height: 80vh; /* Restrict height for scroll */
    overflow-y: auto; /* Enable vertical scrolling */
  }

  .manager-modal-paper {
    width: 70%;
    height: 80%;
    max-width: 80%;
    padding: 16px; /* Adds some padding inside the modal */
    background-color: #fff; /* Ensures consistent background */
    border-radius: 8px !important; /* Rounds corners for a modern look */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Adds a subtle shadow */
  }





  /* Modal container for Overall Rating */
/* Modal container */
.modal-overall-container {
  width: 100% !important;
  max-width: 1000px !important;
  height: 80%;
  padding: 16px; /* Adds some padding inside the modal */
  background-color: #fff; /* Ensures consistent background */
  border-radius: 8px !important; /* Rounds corners for a modern look */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* Title styling */
.modal-overall-title {
  font-family: "Inter";
    font-size: 24px !important;
    font-weight: 600 !important;
    line-height: 21.78px !important;
    letter-spacing: 0.02em !important;
    text-align: left;
    color: #0070E9 !important;
}

/* Flexbox layout for the content area */
.modal-overall-content {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

/* Chart container */
.modal-overall-left {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Right side input area */
.modal-overall-right {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Text fields for areas of improvement and achievements */
.modal-overall-input {
  margin-bottom: 10px;
}

/* Styling for the chart */
.modal-overall-chart {
  width: 80%;
  height: auto;
}

/* Actions (Close button) */
.modal-overall-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.modal-overall-actions button {
  padding: 10px 20px;
  border: none;
  background-color: #4caf50;
  color: white;
  font-size: 14px;
  font-weight: bold;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.modal-overall-actions button:hover {
  background-color: #45a049;
}

.modal-overall-actions button:focus {
  outline: none;
}

.self-cancelButton {
  width: 97px !important;
  height: 39px !important;
  border-radius: 3px;
  border: 1px solid #FE602F !important;
  color: #FE602F !important;
  font-family: "Inter" !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 19px !important;
  letter-spacing: 0.02em !important;
  text-align: center !important;
  background-color: transparent; /* Default background */
  transition: all 0.3s ease; /* Smooth transition for hover */
}

.self-cancelButton:hover {
  background-color: #FE602F !important; /* Orange background on hover */
  color: #FFFFFF !important; /* White text on hover */
}

/* Save Button Styles with Hover */
.self-saveButton {
  width: 80px !important;
  height: 39px !important;
  border-radius: 3px !important;
  background-color: #FE602F !important;
  color: #FFFFFF !important;
  font-family: "Inter" !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 19px !important;
  letter-spacing: 0.02em !important;
  text-align: center !important;
  border: none; /* Remove border for save button */
  transition: all 0.3s ease; /* Smooth transition for hover */
}

.self-saveButton:hover {
  background-color: #D94C1E !important; /* Slightly darker orange on hover */
  color: #FFFFFF !important; /* Keep text white */
}


  `, "",{"version":3,"sources":["webpack://./src/views/panel/PerformanceManagement/ManagerView/ManagerView.css"],"names":[],"mappings":"AAAA;IACI,aAAa;;AAEjB;AACA;IACI,4BAA4B;IAC5B,0BAA0B;IAC1B,sBAAsB;IACtB,2BAA2B;IAC3B,8BAA8B;IAC9B,2BAA2B;IAC3B,kCAAkC;EACpC;EACA;IACE,qDAAqD;EACvD;EACA;IACE,sBAAsB;IACtB,2CAA2C;;EAE7C;;EAEA;IACE,6BAA6B;IAC7B,QAAQ;IACR,UAAU;IACV,sBAAsB;IACtB,2DAA2D;EAC7D;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;EACA;IACE,oCAAoC;IACpC,sBAAsB;IACtB,YAAY;IACZ,6BAA6B;IAC7B,6BAA6B;IAC7B,0BAA0B;IAC1B,sEAAsE;EACxE;;EAEA;IACE,oCAAoC,EAAE,0BAA0B;IAChE,iCAAiC,EAAE,mBAAmB;IACtD,yCAAyC;EAC3C;;EAEA;IACE,wBAAwB;IACxB,kCAAkC;IAClC,8BAA8B;IAC9B,2BAA2B;IAC3B,qBAAqB,EAAE,qBAAqB;IAC5C,uBAAuB;IACvB,0BAA0B;IAC1B,sDAAsD,EAAE,kBAAkB;EAC5E;;EAEA,gBAAgB;EAChB;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA,gBAAgB;EAChB;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,kBAAkB;EAClB;IACE,wBAAwB;IACxB,oCAAoC;IACpC,oBAAoB;IACpB,2BAA2B;EAC7B;;EAEA,YAAY;EACZ;IACE,4BAA4B;IAC5B,oCAAoC;IACpC,sBAAsB;;IAEtB;QACI,oCAAoC;IACxC;EACF;;EAEA;IACE,4BAA4B;IAC5B,sBAAsB;IACtB,oCAAoC;;;IAGpC;QACI,oCAAoC;IACxC;EACF;;;EAGA,qDAAqD;EACrD;IACE,mBAAmB;IACnB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,yBAAyB,EAAE,0CAA0C;IACrE,mBAAmB,EAAE,kCAAkC;EACzD;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,SAAS,EAAE,4CAA4C;EACzD;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,cAAc,EAAE,8BAA8B;EAChD;;;EAGA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,cAAc;IACd,cAAc;IACd,yBAAyB,EAAE,qBAAqB;IAChD,2CAA2C,EAAE,kBAAkB;IAC/D,aAAa;IACb,mBAAmB;IACnB,gBAAgB,EAAE,+BAA+B;IACjD,gBAAgB,EAAE,8BAA8B;EAClD;;EAEA,mBAAmB;EACnB;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;;EAElB;;EAEA,iBAAiB;EACjB;IACE,YAAY,EAAE,eAAe;IAC7B,aAAa,EAAE,iBAAiB;IAChC,kBAAkB;IAClB,eAAe;IACf,aAAa,EAAE,gBAAgB;IAC/B,kBAAkB;IAClB,2CAA2C,EAAE,wBAAwB;IACrE,mBAAmB,EAAE,oBAAoB;IACzC,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB,EAAE,2BAA2B;IACtD,mEAAmE;EACrE;;EAEA,sBAAsB;EACtB;IACE,sBAAsB,EAAE,mCAAmC;IAC3D,2CAA2C,EAAE,6BAA6B;EAC5E;;EAEA,uBAAuB;EACvB;IACE,kBAAkB,EAAE,gCAAgC;EACtD;;EAEA,iBAAiB;EACjB;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,eAAe;IACf,2BAA2B;IAC3B,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;;AAEvB;;EAEE,kBAAkB;EAClB;IACE,4BAA4B;IAC5B,0BAA0B;IAC1B,sBAAsB;IACtB,2BAA2B;IAC3B,8BAA8B;IAC9B,2BAA2B;IAC3B,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB,EAAE,oCAAoC;EACxD;;EAEA;;;;;;;;;;;;KAYG;;EAEH,gCAAgC;EAChC;IACE,UAAU;EACZ;;EAEA;IACE,yBAAyB,EAAE,6BAA6B;IACxD,kBAAkB,EAAE,sBAAsB;EAC5C;;EAEA;IACE,yBAAyB,EAAE,yBAAyB;EACtD;;EAEA;IACE,mBAAmB,EAAE,+BAA+B;EACtD;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kCAAkC;EACpC;;EAEA;IACE,cAAc,EAAE,iCAAiC;EACnD;;EAEA,iBAAiB;EACjB;IACE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB,EAAE,oBAAoB;IAC/C,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,6CAA6C;EAC/C;;EAEA;IACE,yBAAyB,EAAE,yBAAyB;EACtD;;;EAGA,kBAAkB;AACpB;IACI,wBAAwB;IACxB,kCAAkC;IAClC,8BAA8B;IAC9B,2BAA2B;IAC3B,qBAAqB,EAAE,qBAAqB;IAC5C,uBAAuB;IACvB,0BAA0B;IAC1B,sDAAsD,EAAE,kBAAkB;EAC5E;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf,yBAAyB,EAAE,+BAA+B;EAC1D,mBAAmB;EACnB,gBAAgB;EAChB,SAAS,EAAE,8BAA8B;EACzC;;EAEA;IACE,4BAA4B;IAC5B,oCAAoC;IACpC,sBAAsB;;IAEtB;QACI,oCAAoC;IACxC;EACF;EACA;IACE,4BAA4B;IAC5B,sBAAsB;IACtB,oCAAoC;;;IAGpC;QACI,oCAAoC;IACxC;EACF;;;EAGA;IACE,gBAAgB;EAClB;;EAEA;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,cAAc;IACd,cAAc;IACd,yBAAyB,EAAE,qBAAqB;IAChD,2CAA2C,EAAE,kBAAkB;IAC/D,aAAa;IACb,mBAAmB;IACnB,gBAAgB,EAAE,+BAA+B;IACjD,gBAAgB,EAAE,8BAA8B;EAClD;;EAEA;IACE,UAAU;IACV,WAAW;IACX,cAAc;IACd,aAAa,EAAE,uCAAuC;IACtD,sBAAsB,EAAE,kCAAkC;IAC1D,6BAA6B,EAAE,qCAAqC;IACpE,wCAAwC,EAAE,yBAAyB;EACrE;;;;;;EAMA,uCAAuC;AACzC,oBAAoB;AACpB;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,WAAW;EACX,aAAa,EAAE,uCAAuC;EACtD,sBAAsB,EAAE,kCAAkC;EAC1D,6BAA6B,EAAE,qCAAqC;EACpE,wCAAwC;AAC1C;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;IAClB,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;IAC/B,iCAAiC;IACjC,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,0DAA0D;AAC1D;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,UAAU;EACV,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,iCAAiC;EACjC,6BAA6B;EAC7B,6BAA6B,EAAE,uBAAuB;EACtD,yBAAyB,EAAE,gCAAgC;AAC7D;;AAEA;EACE,oCAAoC,EAAE,+BAA+B;EACrE,yBAAyB,EAAE,wBAAwB;AACrD;;AAEA,kCAAkC;AAClC;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,oCAAoC;EACpC,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,iCAAiC;EACjC,6BAA6B;EAC7B,YAAY,EAAE,kCAAkC;EAChD,yBAAyB,EAAE,gCAAgC;AAC7D;;AAEA;EACE,oCAAoC,EAAE,oCAAoC;EAC1E,yBAAyB,EAAE,oBAAoB;AACjD","sourcesContent":[".CardDisplay{\n    display: flex;\n    \n}\n.template-name {\n    font-weight: bold !important;\n    font-size: 1rem !important;\n    color: #333 !important;\n    margin-top: 10px !important;\n    white-space: nowrap !important;\n    overflow: hidden !important;\n    text-overflow: ellipsis !important;\n  }\n  .card-style{\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n  }\n  .card-style:hover {\n    transform: scale(1.05);\n    box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.2);\n    \n  }\n\n  .icon-button {\n    position: absolute !important;\n    top: 5px;\n    right: 5px;\n    background-color: #999;\n    transition: background-color 0.3s ease, transform 0.3s ease;\n  }\n  \n  .icon-button:hover {\n    background-color: #484646;\n    transform: scale(1.1);\n  }\n  .BackBtn {\n    background-color: #82b2e4 !important;\n    color: #fff !important;\n    border: none;\n    border-radius: 5px !important;\n    padding: 10px 20px !important;\n    cursor: pointer !important;\n    transition: background-color 0.3s ease, transform 0.3s ease !important;\n  }\n  \n  .BackBtn:hover {\n    background-color: #2066b1 !important; /* Darker shade on hover */\n    transform: scale(1.05) !important; /* Slight zoom-in */\n    border-radius: 5px 5px 5px 5px !important;\n  }\n\n  .custom-modal-box-template {\n    padding: 24px !important;\n    background-color: white !important;\n    border-radius: 10px !important;\n    max-width: 500px !important;\n    width: 90% !important; /* Responsive width */\n    margin: auto !important;\n    margin-top: 10% !important;\n    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.2) !important; /* Subtle shadow */\n  }\n  \n  /* Modal Title */\n  .modal-title-template {\n    font-size: 20px !important;\n    font-weight: bold !important;\n    margin-bottom: 16px !important;\n    text-align: center !important;\n  }\n  \n  /* Modal Input */\n  .modal-input-template .MuiOutlinedInput-root {\n    border-radius: 8px !important;\n  }\n  \n  .modal-input-template .MuiInputLabel-root {\n    font-size: 14px !important;\n  }\n  \n  /* Modal Actions */\n  .modal-actions {\n    display: flex !important;\n    justify-content: flex-end !important;\n    gap: 16px !important;\n    margin-top: 24px !important;\n  }\n  \n  /* Buttons */\n  .save-button-template {\n    padding: 8px 16px !important;\n    background-color: #0070E9 !important;\n    color: #fff !important;\n\n    &:hover {\n        background-color: #005bb5 !important;\n    }\n  }\n  \n  .cancel-button-template {\n    padding: 8px 16px !important;\n    color: #555 !important;\n    background-color: #f0f0f0 !important;\n    \n\n    &:hover {\n        background-color: #e0e0e0 !important;\n    }\n  }\n\n\n  /* ///////////////////////add goals//////////////// */\n  .add-goals-container {\n    /* padding: 20px; */\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .toggle-container {\n    display: flex;\n    justify-content: flex-end; /* Positions the toggle to the right end */\n    align-items: center; /* Aligns the content vertically */\n  }\n  \n  .toggle-wrapper {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px; /* Adds space between the toggle and label */\n  }\n  \n  .toggle-label {\n    color: gray;\n    font-size: 14px;\n  }\n  \n  .toggle-label.enabled {\n    color: #00b562; /* Change color when enabled */\n  }\n\n\n  .assign-modal-box {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    min-width: 50%;\n    max-width: 60%;\n    background-color: #ffffff; /* White background */\n    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1); /* Subtle shadow */\n    padding: 20px;\n    border-radius: 10px;\n    max-height: 80vh; /* Restrict height for scroll */\n    overflow-y: auto; /* Enable vertical scrolling */\n  }\n  \n  /* Card Container */\n  .assign-card-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n    margin-top: 30px;\n   \n  }\n  \n  /* Card Styling */\n  .assign-card-style {\n    width: 150px; /* Card width */\n    padding: 20px; /* Card padding */\n    text-align: center;\n    cursor: pointer;\n    height: 150px; /* Card height */\n    position: relative;\n    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1); /* Shadow for the card */\n    border-radius: 10px; /* Rounded corners */\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-color: #f9f9f9; /* Light background color */\n    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n  }\n  \n  /* Card Hover Effect */\n  .assign-card-style:hover {\n    transform: scale(1.05); /* Slightly enlarge card on hover */\n    box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.2); /* Stronger shadow on hover */\n  }\n  \n  /* Card Media (Image) */\n  .assign-card-media {\n    border-radius: 5px; /* Rounded edges for the image */\n  }\n  \n  /* Card Content */\n  .assign-card-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 10px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .leavemanageHeadingcopy {\n    font-family: \"Inter\";\n    font-size: 22px;\n    font-weight: 600 !important;\n    line-height: 21.78px;\n    letter-spacing: 0.02em;\n    text-align: left;\n    color: #0070E9;\n    align-items: center;\n\n}\n  \n  /* Template Name */\n  .assign-template-name {\n    font-weight: bold !important;\n    font-size: 1rem !important;\n    color: #333 !important;\n    margin-top: 10px !important;\n    white-space: nowrap !important;\n    overflow: hidden !important;\n    text-overflow: ellipsis !important;\n    position: relative;\n    max-width: 200px; /* Set a width to trigger ellipsis */\n  }\n\n  /* .assign-template-name:hover {\n    overflow: visible !important;\n    animation: slide 5s linear infinite;\n  }\n  \n  @keyframes slide {\n    0% {\n      transform: translateX(-10);\n    }\n    100% {\n      transform: translateX(-100%);\n    }\n  } */\n  \n  /* Scrollbar Styling for Modal */\n  .assign-modal-box::-webkit-scrollbar {\n    width: 8px;\n  }\n  \n  .assign-modal-box::-webkit-scrollbar-thumb {\n    background-color: #d6d6d6; /* Grey color for scrollbar */\n    border-radius: 5px; /* Rounded scrollbar */\n  }\n  \n  .assign-modal-box::-webkit-scrollbar-thumb:hover {\n    background-color: #a8a8a8; /* Darker grey on hover */\n  }\n  \n  .assign-modal-box::-webkit-scrollbar-track {\n    background: #f1f1f1; /* Light background for track */\n  }\n\n  .assign-close-icon {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    font-size: 20px;\n    font-weight: bold;\n    color: #333333;\n    cursor: pointer;\n    transition: color 0.2s ease-in-out;\n  }\n  \n  .assign-close-icon:hover {\n    color: #ff0000; /* Change color to red on hover */\n  }\n  \n  /* Close Button */\n  .assign-close-button {\n    margin-top: 20px;\n    display: block;\n    padding: 10px 20px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #ffffff;\n    background-color: #007bff; /* Blue background */\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.2s ease-in-out;\n  }\n  \n  .assign-close-button:hover {\n    background-color: #0056b3; /* Darker blue on hover */\n  }\n\n\n  /* EditModal.css */\n.editmodal-container {\n    padding: 24px !important;\n    background-color: white !important;\n    border-radius: 10px !important;\n    max-width: 500px !important;\n    width: 90% !important; /* Responsive width */\n    margin: auto !important;\n    margin-top: 10% !important;\n    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.2) !important; /* Subtle shadow */\n  }\n  \n  .editmodal-title {\n    font-size: 20px !important;\n    font-weight: bold !important;\n    margin-bottom: 16px !important;\n    text-align: center !important;\n  }\n  \n  .editmodal-item {\n    margin-bottom: 15px;\n    font-size: 1rem;\n  }\n  \n  .editmodal-item strong {\n    font-weight: bold;\n  }\n\n  .editmodal-button{\n    display: flex;\n  justify-content: flex-end; /* Align buttons to the right */\n  align-items: center;\n  margin-top: 20px;\n  gap: 20px; /* Add space between buttons */\n  }\n  \n  .editmodal-Savebutton {\n    padding: 8px 16px !important;\n    background-color: #0070E9 !important;\n    color: #fff !important;\n\n    &:hover {\n        background-color: #005bb5 !important;\n    }\n  }\n  .editmodal-Cancelbutton {\n    padding: 8px 16px !important;\n    color: #555 !important;\n    background-color: #f0f0f0 !important;\n    \n\n    &:hover {\n        background-color: #e0e0e0 !important;\n    }\n  }\n  \n  \n  .editmodal-input {\n    margin-top: 10px;\n  }\n  \n  @media (max-width: 600px) {\n    .editmodal-container {\n      width: 90%;\n    }\n  }\n\n  .view-modal-box {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    min-width: 50%;\n    max-width: 60%;\n    background-color: #ffffff; /* White background */\n    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1); /* Subtle shadow */\n    padding: 20px;\n    border-radius: 10px;\n    max-height: 80vh; /* Restrict height for scroll */\n    overflow-y: auto; /* Enable vertical scrolling */\n  }\n\n  .manager-modal-paper {\n    width: 70%;\n    height: 80%;\n    max-width: 80%;\n    padding: 16px; /* Adds some padding inside the modal */\n    background-color: #fff; /* Ensures consistent background */\n    border-radius: 8px !important; /* Rounds corners for a modern look */\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Adds a subtle shadow */\n  }\n\n\n\n\n\n  /* Modal container for Overall Rating */\n/* Modal container */\n.modal-overall-container {\n  width: 100% !important;\n  max-width: 1000px !important;\n  height: 80%;\n  padding: 16px; /* Adds some padding inside the modal */\n  background-color: #fff; /* Ensures consistent background */\n  border-radius: 8px !important; /* Rounds corners for a modern look */\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n/* Title styling */\n.modal-overall-title {\n  font-family: \"Inter\";\n    font-size: 24px !important;\n    font-weight: 600 !important;\n    line-height: 21.78px !important;\n    letter-spacing: 0.02em !important;\n    text-align: left;\n    color: #0070E9 !important;\n}\n\n/* Flexbox layout for the content area */\n.modal-overall-content {\n  display: flex;\n  justify-content: space-between;\n  gap: 20px;\n}\n\n/* Chart container */\n.modal-overall-left {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Right side input area */\n.modal-overall-right {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* Text fields for areas of improvement and achievements */\n.modal-overall-input {\n  margin-bottom: 10px;\n}\n\n/* Styling for the chart */\n.modal-overall-chart {\n  width: 80%;\n  height: auto;\n}\n\n/* Actions (Close button) */\n.modal-overall-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.modal-overall-actions button {\n  padding: 10px 20px;\n  border: none;\n  background-color: #4caf50;\n  color: white;\n  font-size: 14px;\n  font-weight: bold;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.modal-overall-actions button:hover {\n  background-color: #45a049;\n}\n\n.modal-overall-actions button:focus {\n  outline: none;\n}\n\n.self-cancelButton {\n  width: 97px !important;\n  height: 39px !important;\n  border-radius: 3px;\n  border: 1px solid #FE602F !important;\n  color: #FE602F !important;\n  font-family: \"Inter\" !important;\n  font-size: 16px !important;\n  font-weight: 600 !important;\n  line-height: 19px !important;\n  letter-spacing: 0.02em !important;\n  text-align: center !important;\n  background-color: transparent; /* Default background */\n  transition: all 0.3s ease; /* Smooth transition for hover */\n}\n\n.self-cancelButton:hover {\n  background-color: #FE602F !important; /* Orange background on hover */\n  color: #FFFFFF !important; /* White text on hover */\n}\n\n/* Save Button Styles with Hover */\n.self-saveButton {\n  width: 80px !important;\n  height: 39px !important;\n  border-radius: 3px !important;\n  background-color: #FE602F !important;\n  color: #FFFFFF !important;\n  font-family: \"Inter\" !important;\n  font-size: 16px !important;\n  font-weight: 600 !important;\n  line-height: 19px !important;\n  letter-spacing: 0.02em !important;\n  text-align: center !important;\n  border: none; /* Remove border for save button */\n  transition: all 0.3s ease; /* Smooth transition for hover */\n}\n\n.self-saveButton:hover {\n  background-color: #D94C1E !important; /* Slightly darker orange on hover */\n  color: #FFFFFF !important; /* Keep text white */\n}\n\n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
